<template>
  <!--mobHeader-->
  <div class="p-[1rem] flex justify-around md:hidden">
    <div @click="this.toggleNavBurger = !this.toggleNavBurger" class="cursor-pointer w-max">
      <img v-if="!toggleNavBurger" src="@/assets/nav/hamburger.svg" class="w-[21px] h-[24px] object-contain"
        fetchPriority="low" alt="hamburger image" />

      <img v-else src="@/assets/nav/x_mark.svg" alt="close button" class="w-[21px] h-[24px] object-contain" />
    </div>
    <div class="flex">
      <div class="flex">
        <router-link :to="{ name: 'home' }">
          <img src="@/assets/home/jainLogo.svg" alt="jainLogo" class="w-[143px] h-[23px] object-contain"
            fetchPriority="high" />
        </router-link>
      </div>

      <!-- search -->
      <div>
        <div class="relative">
          <div class="ml-[.8rem] xl:mr-[1rem] xl:mt-[2px] cursor-pointer" v-if="shouldShowIcon" @click="toggleSearch">
            <img src="@/assets/home/Icon-feather-search.svg" class="w-[21px] h-[24px]" alt="search" title="Search" />
          </div>

          <!-- Search input -->
          <div ref="searchBox" v-if="showSearch" class="search-box left-[-220px] top-[60px] flex gap-2 items-center">
            <input class="search-input w-[250px]" type="text" placeholder="Search..." @input="fetchResults"
              @keyup.enter="goToSearchPage" />
          </div>
          <!-- Suggestions dropdown -->
          <ul v-if="showSuggestions"
            class="search-suggestions absolute bg-white shadow-lg top-[110px] w-[290px] !left-[-220px] z-50">
            <li v-for="result in searchResults.slice(0, 6)" :key="result.id" @click="selectResult(result)">
              <a :href="`/${result.program.short_slug}/${result.slug}`" v-if="result" class="flex gap-3 items-center">
                <p class="text-black text-[12px] text-start text-wrap font-semibold">
                  {{ result.program.short_name }} in
                  {{ result.name }}
                </p>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!-- search -->

      <router-link :to="{ name: 'NotificationView' }" title="notifications information">
        <div class="ml-[1.5rem]">
          <img src="@/assets/home/Icon-feather-bell.svg" alt="redirect to notification page"
            class="w-[19px] h-[21px]" />
        </div>
      </router-link>
    </div>
  </div>
  <!--mobHeader-->
  <!--mobhambergerContent-->
  <div
    class=" md:hidden absolute z-10 top-15 w-full h-[100vh] bg-[#EFEFEF] border-[#EFEFEF] border-l-4 p-5 sm:px-0 shrink-0 transition-all duration-500 ease-in-out overflow-y-auto"
    v-if="toggleNavBurger">
    <!--toggle content-->
    <div v-for="tab in hambergerContent" :key="tab.id" class="flex justify-center flex-col items-center">
      <div
        class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem]"
        @click="toggleTab(tab.id)" :class="activeTab == null
          ? ''
          : 'shadow-none bg-none hover:bg-[#efefef]'
          ">
        <div class="tab-heading px-2 font-bold flex items-center">
          <span class="px-2" v-if="activeTab == tab.id">
            <img src="@/assets/nav/left-arrow.webp" class="w-[10px] h-[16px] object-contain" fetchPriority="low"
              alt="left arrow" />
          </span>
          {{ tab.title }}
        </div>
        <div class="px-2" v-if="activeTab != tab.id">
          <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" fetchPriority="low"
            alt="right arrow" />
        </div>
      </div>
      <div v-if="activeTab === tab.id" class="mt-2">
        <div class="ml-3" v-show="tab.id == 'tab1'">
          <div>
            <h2 class="text-[#001C54] text-lg w-max">
              Our Leading Offerings
            </h2>
            <a href="/online-mba/ai-driven-marketing">
              <div
                class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2">
                MBA in AI-Driven Marketing
                <div class="">
                  <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" fetchPriority="low"
                    alt="right arrow" />
                </div>
              </div>
            </a>
            <a href="/online-mba/ai-driven-finance">
              <div
                class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2">
                MBA in AI-Driven Finance
                <div class="">
                  <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" fetchPriority="low"
                    alt="right arrow" />
                </div>
              </div>
            </a>
            <a href="/online-mba/ai-driven-business-strategy">
              <div
                class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2">
                MBA in AI-Driven Business Strategy
                <div class="">
                  <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" fetchPriority="low"
                    alt="right arrow" />
                </div>
              </div>
            </a>
            <a href="/online-mba/ai-driven-human-resources">
              <div
                class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2">
                MBA in AI-Driven Human Resources
                <div class="">
                  <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" fetchPriority="low"
                    alt="right arrow" />
                </div>
              </div>
            </a>
            <a href="/online-mca/data-analytics">
              <div
                class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2">
                MCA in Data Analytics
                <div class="">
                  <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" fetchPriority="low"
                    alt="right arrow" />
                </div>
              </div>
            </a>
            <a href="/online-mca/cyber-security">
              <div
                class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2">
                MCA in Cyber Security
                <div class="">
                  <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" fetchPriority="low"
                    alt="right arrow" />
                </div>
              </div>
            </a>
          </div>
          <!--Browse by programs-->
          <div class="mt-2">
            <h2 class="text-[#001C54] text-lg w-max">
              Browse by Programs
            </h2>
            <div v-for="el in navElectives" :key="el.id">
              <div
                class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2"
                @click="navProgramInfo(el.id), changeElecBg(el.name),isCertificateMenuEnabled = false">
                {{ el.name }} Programs
                <div class="">
                  <img src="@/assets/nav/right-arrow.webp" class="w-[16px] h-[16px] object-contain" fetchPriority="low"
                    alt="right arrow" />
                </div>
              </div>
              <div v-show="el.name == programBg">
                <div v-for="el in navPrograms" :key="el.id">
                  <div
                    class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2"
                    @click="
                      navCourseInfo(el.id), changeProgramBg(el.short_name)
                      ">
                    {{ el.short_name }}
                    <div class="">
                      <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain"
                        fetchPriority="low" alt="right arrow" />
                    </div>
                  </div>
                  <div v-show="el.short_name == courseBgMob">

                    <div class="m-2 mt-5" v-for="content in navCourses.slice(0, 1)" :key="content.id">
                      <h2 class="text-left">
                        <a :href="`/${content.program.slug}`" class="bg-[#001c54] p-1 rounded-3xl px-3 py-2">
                          <span class="text-[#F8C300]">
                            Online {{ content.program.short_name }}
                          </span>
                        </a>
                      </h2>
                    </div>
                    <div v-for="el in navCourses" :key="el.id">
                      <a :href="`/${el.program.short_slug}/${el.slug}`" class="flex justify-between items-center">
                        <div class="text-start mt-2 w-[17rem]">
                          {{ el.name }}
                        </div>
                        <div class="pt-2">
                          <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain"
                            fetchPriority="low" alt="right arrow" />
                        </div>
                      </a>
                    </div>


                  </div>
                </div>

              </div>
            </div>
            <div
              class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2"
              @click="isCertificateMenuEnabled = true, navProgramInfo(0), changeElecBg('certification')"
              :class="isCertificateMenuEnabled ? 'bg-[#efefef]' : ''">
              <h3 class="font-bold   text-md lg:text-base px-2">
                Certifications
              </h3>
              <div class="">
                <img src="@/assets/nav/right-arrow.webp" class="w-[16px] h-[16px] object-contain" fetchPriority="low"
                  alt="right arrow" />
              </div>
            </div>
            <div v-if="isCertificateMenuEnabled" class="mt-[2rem]  p-2 flex">
              <div>
                <div class="mb-2" v-for="content in navCourses.slice(0, 1)" :key="content.id">
                  <h2 class="flex items-center text-left">
                    <a href="/genai-certification" class="bg-[#001c54] p-1 rounded-3xl px-3 py-2">
                      <span class="text-[#F8C300]">
                        Online Certification
                      </span>
                    </a>
                    &nbsp; Programs Offered
                  </h2>
                </div>

                <div
                  class="">
                  <a href="/genai-certification" class="flex justify-between items-center">
                    <div class="text-start mt-2 w-[17rem]">
                      Generative AI Certificate Program
                    </div>
                    <div class="pt-2">
                      <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain"
                        fetchPriority="low" alt="right arrow" />
                    </div>
                  </a>

                </div>

              </div>
            </div>
          </div>
          <!--Browse by programs-->
          <!--Browse by domains-->
          <!-- <div class="mt-2">
                  <h2 class="text-[#001C54] text-lg w-max">Browse by Domain</h2>
                  <div></div>
                  <div v-for="domain in navCourses" :key="domain.id">
                    <a
                      :href="`/${domain.program.short_slug}/${domain.slug}`"
                      class="flex justify-between items-center text-sm py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2"
                    >
                      {{ modifiedSlug(domain.slug) }}
                      <div class="">
                        <img
                          src="@/assets/nav/right-arrow.webp"
                          class="w-[10px] h-[16px] object-contain"
                          alt="right arrow"
                        />
                      </div>
                    </a>
                  </div>
                </div> -->
          <!--Browse by domains-->
        </div>
        <div v-show="tab.id == 'tab2'" class="ml-3">
          <a href="https://www.jainuniversity.ac.in/" @click="
            handleLinkClick(
              'Jain University',
              'Why Us',
              'https://www.jainuniversity.ac.in/'
            )
            ">
            <div
              class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2">
              JAIN University
              <div class="">
                <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow" />
              </div>
            </div>
          </a>
          <a href="/technology/" @click="
            handleLinkClick(
              'Technology',
              'Why Us',
              'https://onlinejain.com/technology'
            )
            ">
            <div
              class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2">
              Technology
              <div class="">
                <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow" />
              </div>
            </div>
          </a>

          <a href="/testimonial" @click="
            handleLinkClick(
              'Success Stories',
              'Why Us',
              'https://onlinejain.com/testimonial'
            )
            ">
            <div
              class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2">
              Success Stories
              <div class="">
                <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow" />
              </div>
            </div>
          </a>

          <a href="/academics/" @click="
            handleLinkClick(
              'Our Teaching',
              'Why Us',
              'https://onlinejain.com/academics'
            )
            ">
            <div
              class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2">
              Our Teaching
              <div class="">
                <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow" />
              </div>
            </div>
          </a>

          <a href="/life-at-jo/" title="Life At JO" @click="
            handleLinkClick(
              'Life At JO',
              'Why Us',
              'https://onlinejain.com/life-at-jo'
            )
            ">
            <div
              class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2">
              Life At JO
              <div class="">
                <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow" />
              </div>
            </div>
          </a>

          <a href="/careers/" @click="
            handleLinkClick(
              'Career Growth',
              'Why Us',
              'https://onlinejain.com/careers/'
            )
            ">
            <div
              class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2">
              Career Growth
              <div class="">
                <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow" />
              </div>
            </div>
          </a>

          <a href="/blogs/" @click="
            handleLinkClick(
              'Blogs',
              'Why US',
              'https://onlinejain.com/blogs/'
            )
            ">
            <div
              class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2">
              Blogs
              <div class="">
                <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow" />
              </div>
            </div>
          </a>

          <a href="/micro-credentials-online-courses/" @click="
            handleLinkClick(
              'Micro Credential',
              'Why Us',
              'https://onlinejain.com/micro-credentials-online-courses/'
            )
            ">
            <div
              class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2">
              Micro Credential
              <div class="">
                <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow" />
              </div>
            </div>
          </a>
        </div>
        <div v-show="tab.id == 'tab3'" class="ml-3">
          <a href="/faqs" @click="
            handleLinkClick(
              'FAQs',
              'Support',
              'https://onlinejain.com/faqs'
            )
            ">
            <div
              class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2">
              FAQs
              <div class="">
                <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow" />
              </div>
            </div>
          </a>
          <div @click="
            is_download_brochure_navAll = true;
          pushBrochureDownloadDataLayer({
            electiveTitle: 'Overall Brochure',
            ctaSection: 'Nav Bar',
          });
          handleLinkClick(
            'Download Brochure',
            'Support',
            'Overall Brochure'
          );
          "
            class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2">
            <div class="text-md">Download Brochure</div>

            <div class="">
              <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow" />
            </div>
          </div>

          <a href="/contact-us/" @click="
            handleLinkClick(
              'Contact Us',
              'Support',
              'https://onlinejain.com/contact-us/'
            )
            ">
            <div
              class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2">
              Contact Us
              <div class="">
                <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow" />
              </div>
            </div>
          </a>

          <a href="https://support.onlinejain.com/" @click="
            handleLinkClick(
              'Student Support',
              'Support',
              'https://support.onlinejain.com/'
            )
            ">
            <div
              class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2">
              Student Support
              <div class="">
                <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow" />
              </div>
            </div>
          </a>

          <a href="/grievance-redressal/" @click="
            handleLinkClick(
              'Grievance Redressal',
              'Support',
              'https://onlinejain.com/grievance-redressal/'
            )
            ">
            <div
              class="flex justify-between w-[20rem] items-center py-6 shadow-lg bg-[white] hover:bg-[#F8C300] rounded-lg mt-[1rem] px-2">
              Grievance Redressal
              <div class="">
                <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow" />
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <!--toggle content-->
    <!--enquire now form-->
    <!-- <div
            class="mr-[1rem] flex items-center w-[8rem] bg-[#F8C300] rounded-full py-2 px-4 cursor-pointer mt-6"
            @click="enquire_now = true"
            ref="dropDownBtnProgram"
          >
            <span class="text-sm text-center lg:text-lg text-black font-bold">
              Enquire Now
            </span>
          </div> -->
    <!--enquire now form-->
    <!--searchbar-->
    <div
      class="flex justify-center items-center md:justify-between bg-white w-max p-[.4rem] px-[2rem] rounded-full shadow-lg mt-[5rem] m-auto">
      <span>
        <input type="text" placeholder="Search your next degree" class="rounded-full outline-none p-[.4rem]" />
      </span>
      <span class="flex justify-center h-full">
        <span class="pt-[4px] border-r-[1px] pr-2">
          <img src="@/assets/nav/magnifying-glass.svg" class="w-[16px] h-[16px] object-contain"
            alt="magnifying glass" />
        </span>
        <span class="ml-2 pt-1">
          <img src="@/assets/home/Icon-feather-mic.svg" class="w-[90%]" alt="iconFeather" />
        </span>
      </span>
    </div>
    <!--searchbar-->
    <!--coursese-->
    <div class="pt-[10px]">
      <div class="flex gap-4 md:flex-wrap overflow-x-scroll mt-4 justify-center scrollBehaviour">
        <div class="flex flex-col w-max items-center">
          <div
            class="rounded-full border-[#F8C300] border-[1px] w-[3.5rem] h-[3.5rem] bg-white flex justify-center items-center">
            <div>
              <img src="@/assets/home/mbaInFinance.svg" alt="mbaInFinance" />
            </div>
          </div>
          <div class="pt-1 font-medium text-xs w-[5rem]">Finance</div>
        </div>

        <div class="flex flex-col w-max items-center">
          <div
            class="rounded-full border-[#F8C300] border-[1px] w-[3.5rem] h-[3.5rem] bg-white flex justify-center items-center">
            <div>
              <img src="@/assets/home/mbaInHr.svg" alt="mbaInFinance" />
            </div>
          </div>
          <div class="pt-1 font-medium text-xs w-[5rem] 2xl:text-lg">
            Human Resource
          </div>
        </div>

        <div class="flex flex-col w-max items-center">
          <div
            class="rounded-full border-[#F8C300] border-[1px] w-[3.5rem] h-[3.5rem] md:w-[4rem] bg-white flex justify-center items-center">
            <div>
              <img src="@/assets/home/mcaInCS.svg" alt="mbaInFinance" />
            </div>
          </div>
          <div class="pt-1 font-medium text-xs w-[5rem] 2xl:text-lg">
            Computer Science
          </div>
        </div>

        <div class="flex flex-col w-max items-center">
          <div
            class="rounded-full border-[#F8C300] border-[1px] w-[3.5rem] h-[3.5rem] bg-white flex justify-center items-center">
            <div>
              <img src="@/assets/home/mcaInAI.svg" alt="mbaInFinance" />
            </div>
          </div>
          <div class="pt-1 font-medium text-xs w-[5rem] 2xl:text-lg">
            Artificial Intelligence
          </div>
        </div>

        <div class="flex flex-col w-max items-center">
          <div
            class="rounded-full border-[#F8C300] border-[1px] w-[3.5rem] h-[3.5rem] bg-white flex justify-center items-center">
            <div>
              <img src="@/assets/home/mcaInAI.svg" alt="mbaInFinance" />
            </div>
          </div>
          <div class="pt-1 font-medium text-xs w-[5rem] 2xl:text-lg">
            MBA in GM
          </div>
        </div>

        <div class="flex flex-col w-max items-center">
          <div
            class="rounded-full border-[#F8C300] border-[1px] w-[3.5rem] h-[3.5rem] bg-white flex justify-center items-center">
            <div>
              <img src="@/assets/home/mcaInCS.svg" alt="mbaInFinance" />
            </div>
          </div>
          <div class="pt-1 font-medium text-xs w-[5rem] 2xl:text-lg">
            MCA in Computers
          </div>
        </div>
      </div>
    </div>
    <!--coursese-->
  </div>
  <!--mobhambergerContent-->
</template>

<script>
export default {
  data() {
    return {
      toggleNavBurger: false,
      activeTab: null,
    }
  },
  props: [
    "shouldShowIcon",
    "toggleSearch",
    "showSearch",
    "fetchResults",
    "goToSearchPage",
    "showSuggestions",
    "searchResults",
    "hambergerContent",
    "navElectives",
    "navPrograms",
    "navCourses",
    "navProgramInfo",
    "navCourseInfo",
    "changeElecBg",
    "changeProgramBg",
    "courseBgMob",
    "programBg"
  ],
  methods: {
    toggleTab(tabId) {
      if (this.activeTab === tabId) {
        this.activeTab = null;
      } else {
        this.activeTab = tabId;
      }
    },
    handleLinkClick(item) {
      // Emit the item click event with its data
      this.$emit("item-clicked", item);
    },
    pushBrochureDownloadDataLayer(item) {
      // Emit the item click event with its data
      this.$emit("brochure-item-clicked", item);
    },
  }



};
</script>

<style scoped>
.mobile-menu {
  background: white;
  height: 100vh;
}
</style>